<template>
    <div class="resourceList">
        <h1 v-if="title" class="title resourceList__title" :class="{'resourceList__title--loading': isLoading}">
            {{ title }}
            <!--<a href="" v-if="showDeleted">Back to Moderation</a>-->
        </h1>
        <transition-group
            v-if="resources.length > 0"
            name="list"
            tag="div"
            class="resourceList__page"
            :class="{'resourceList__page--loading': isLoading}">
            <resource-card
                v-for="resource in resources"
                :resource="resource"
                :key="resource.id"
                :is-editing="isEdit"
                :can-edit="canEdit"
              />
        </transition-group>
        <div v-if="!isLoading && resources.length === 0">
            No results to display
        </div>

    </div>
</template>

<script>
import ResourceCard from './ResourceCard';

export default {
    props: {
        title: {
            type: String,
        },
        isLoading: {
            type: Boolean,
            default: true
        },
        resources: {
            type: Array,
            default: []
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        showDeleted: {
            type: Boolean,
            default: false
        },
    },
    computed: {
      canEdit() {
        return window.AR.data.me.user_level <= 3;
      },
    },
    mounted() {
      this.isEdit = this.isEditing;
    },
    data() {
        return {
          isEdit: false,
        };
    },
    components: {
        // 'b-loading': Loading,
        'resource-card': ResourceCard
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ResourceList.vue